<template>
    <div class="webview"></div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {

		}
	},

	beforeCreate(){
		if(this.$route.query.name = "course"){
			window.location.href = "https://readapi.bluebirdabc.com/lessonplayer/index.html?userId=1111&pid=&lessonId=80#/"
		}else if(this.$route.query.name = "test"){
			window.location.href = "https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24"
		}else if(this.$route.query.name = "reading"){
			window.location.href = "https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24"
		}else if(this.$route.query.name = "exam"){
			window.location.href = "https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24"
		}else if(this.$route.query.name = "game"){
			window.location.href = "https://read2.bluebirdabc.com/games/ding2"
		}
		console.dir(this.$route.query.name)
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {

	}
}
</script>

<style lang="scss" scoped>

</style>
